export default "__VITE_ASSET__CF6oOxDz__"